import React from "react";
import FormStyle from "../styles/forms.css";
import CommonStyles from "../styles/common.css";
import Styles from "../styles/modal.css";

const inputPrefix = "input";

export default class YbModal extends React.Component {
  constructor(props) {
    super(props);
    this.prefix = new Date().getTime() + "";
    this.onClick = this.onClick.bind(this);
  }

  componentDidUpdate() {
    var body = window.document.body;

    if (document.getElementsByClassName(Styles.modal).length) {
      body.style.overflowY = "hidden";
    } else {
      body.style.overflowY = "auto";
    }
  }

  componentDidMount() {
    this.modalRef = this.refs.modal;
  }

  onClick(event) {
    event.stopPropagation();
  }

  onClose(event) {
    var closeCallback = this.props.closeCallback;
    var onHide = this.props.onHide;

    this.modalRef
      .getElementsByClassName("modal")[0]
      .classList.add(Styles.modalFadeOut);
    setTimeout(() => {
      if (onHide) {
        onHide();
      }

      if (closeCallback) {
        closeCallback();
      }
    }, 350);

    event.stopPropagation();
  }

  render() {
    var prefix = this.prefix;
    var title = this.props.title;
    var onSubmit = this.props.onSubmit;
    var disabled = this.props.disabled;
    var disableSubmit = this.props.disableSubmit;
    var fields = this.props.fields;
    var error = this.props.error;
    var successText = this.props.successText;
    var succesIcon = this.props.succesIcon;
    var noSuccessBtn = this.props.noSuccessBtn;
    var cancelText = this.props.cancelText;
    var bigModal = this.props.bigModal;
    var extraContent = this.props.extraContent;
    var show = this.props.show;
    var showSuccessBtn = !noSuccessBtn && !error;
    var show = this.props.show;

    return (
      <span ref="modal" className={Styles.modalWrapper}>
        {show && (
          <form
            onKeyPress={event => {
              if (event.key === "Enter" && event.target.type !== "submit") {
                event.preventDefault();
              }
            }}
            className={`${Styles.modalForm} ${FormStyle.form} ${
              disabled ? Styles.modalDisabled : ""
            }`}
            onClick={event => event.stopPropagation()}
            onSubmit={event => {
              event.preventDefault();
              return onSubmit(
                fields &&
                  fields.reduce((prev, { key }) => {
                    return {
                      ...prev,
                      [key]: this[`${inputPrefix}-${key}`].value
                    };
                  }, {})
              );
            }}
          >
            <div
              className={`modal fade show ${Styles.modalShow}`}
              id={`${prefix}-modal`}
              tabIndex="-1"
              role="dialog"
              aria-labelledby={`${prefix}-modalLabel`}
              aria-hidden="true"
            >
              <div
                className={`${Styles.modal} modal-dialog ${
                  bigModal ? Styles.bigModal : ""
                }`}
                role="document"
              >
                <div className={Styles.modalContent}>
                  <div className="modal-header">
                    <h5
                      className={Styles.modalTitle}
                      id={`${prefix}-modalLabel`}
                    >
                      {title}
                    </h5>
                    <button
                      disabled={disabled}
                      type="button"
                      className={`${Styles.modalCloseButton} ${
                        FormStyle.crossBtn
                      }`}
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.onClose.bind(this)}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {this.props.children}
                    {fields &&
                      fields.map(
                        ({
                          withPrefix,
                          key,
                          title,
                          placeholder,
                          required = true,
                          type = "text",
                          extra,
                          props,
                          selectOptions
                        }) => (
                          <div key={key} className={FormStyle.row}>
                            <div className={FormStyle.label}>
                              <label>
                                {title}{" "}
                                {required && (
                                  <span className={FormStyle.requiredStar}>
                                    *
                                  </span>
                                )}{" "}
                                {extra}
                              </label>
                            </div>
                            {type !== "select" && (
                              <div
                                className={
                                  withPrefix
                                    ? FormStyle.inputGroupLeftSelect
                                    : ""
                                }
                              >
                                {withPrefix && (
                                  <span className={FormStyle.leftPrefix}>
                                    {withPrefix}
                                  </span>
                                )}
                                <input
                                  {...props}
                                  placeholder={placeholder}
                                  ref={ref =>
                                    (this[`${inputPrefix}-${key}`] = ref)
                                  }
                                  type={type}
                                  required={required}
                                  className="form-control"
                                  id={`${prefix}-${key}`}
                                />
                              </div>
                            )}
                            {type === "select" && (
                              <select
                                {...props}
                                placeholder={placeholder}
                                ref={ref =>
                                  (this[`${inputPrefix}-${key}`] = ref)
                                }
                                type={type}
                                required={required}
                                className="form-control"
                                id={`${prefix}-${key}`}
                              >
                                {selectOptions.map((option, index) => {
                                  return (
                                    <option key={index} value={option.value}>
                                      {option.name}
                                    </option>
                                  );
                                })}
                              </select>
                            )}
                          </div>
                        )
                      )}
                    {extraContent}
                  </div>
                  <div className="modal-footer">
                    <button
                      className={FormStyle.cancelBtn}
                      disabled={disabled}
                      type="button"
                      data-dismiss="modal"
                      onClick={this.onClose.bind(this)}
                    >
                      <i className="fa fa-times" />{" "}
                      {cancelText ? cancelText : i18n`CANCEL`}
                    </button>
                    {showSuccessBtn && (
                      <button
                        className={FormStyle.submitModalBtn}
                        type="submit"
                        disabled={disabled || disableSubmit}
                        onClick={this.onClick}
                      >
                        <i
                          className={`fa ${
                            succesIcon ? succesIcon : "fa-plus"
                          }`}
                        />{" "}
                        {successText ? successText : i18n`CREATE`}
                      </button>
                    )}
                    {error && (
                      <span
                        className={`${CommonStyles.textDanger} ${
                          Styles.errorInModal
                        }`}
                      >
                        {error.message
                          .replace("GraphQL error:", "")
                          .replace(/\-.*/, "")}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className={Styles.modalBlackScreen} />
            </div>
          </form>
        )}
      </span>
    );
  }
}
